// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5738 ? "1484b9de" : chunkId) + "." + {"5738":"925dfac3ae9a5f89","6743":"5433a7e386f85bb1"}[chunkId] + ".js";
};